import * as React from 'react';
import type { StudyAdmissionCallToActionViewModel } from '../ViewModel/StudyAdmissionCallToActionViewModel.csharp';
import { AdmissionCallToAction } from '~/Features/StudyPage/Campus/Partials/AdmissionCallToAction/AdmissionCallToAction';
import { useStudyPageGtmEvents } from '~/Features/StudyPage/Campus/Utils/Hooks/useStudyPageGtmEvents';

export const StudyAdmissionCallToActionBlock: React.FC<StudyAdmissionCallToActionViewModel> = props => {
    const { choices, link, status, translations, helperLabel, mainLabel, campusCards, campusApplicationUrl } = props;

    useStudyPageGtmEvents(choices);

    const mapToCTAStatus = () => {
        if (status === undefined) {
            return 'closed';
        }

        return status;
    };

    return (
        <AdmissionCallToAction
            mainLabel={mainLabel}
            helperLabel={helperLabel}
            choices={choices}
            translations={translations}
            status={mapToCTAStatus()}
            link={link}
            campusCards={campusCards}
            campusApplicationUrl={campusApplicationUrl}
        />
    );
};
